export const config = {
  title: 'Self Assign',
  okText: 'Yes',
  cancelText: 'No',
  width: 420,
  bodyText: 'Are you sure you want to assign this job?',
  fields: [],
};
